import React, { ReactElement, Component, useContext, useEffect, Fragment, useMemo } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Select, Row, Col } from "antd";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { item } from "../../contexts/items";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { select_display, select } from "../table-list/table-list";
import { withRouter } from "react-router-dom";
import { NamespaceContext, namespaces_type_item } from "../../contexts/namespaces";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { ClusterContext, clusters_type_item } from "../../contexts/clusters";
import DropdownMenuSubscription from "../dropdown-menu-subscription/dropdown-menu-subscription";
import { useDeepCompareMemo } from 'use-deep-compare';
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";

const DropdownMenuTop: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const clusters: clusters_type_item[] = useContext(ClusterContext)[0],
    [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(
      WorkspaceContext
    ),
    [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>] = useContext(
      NamespaceContext
    ),
    [cluster_selected, set_cluster_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(ClusterSelectedContext),
    [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(
      WorkSpaceSelectedContext
    ),
    [namespace_selected, set_namespace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(
      NameSpaceSelectedContext
    ),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    path = useMemo(() => props.history.location.pathname.substring(1), [props.history.location.pathname]),
    { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
    { Option } = useMemo(() => Select, []),
    is_not_monitor: boolean = useMemo(() => !path.includes("monitor"), [path]);
  const display = useMemo(() => select_display(path), [path]);

  useEffect((): void => {
    // const pathname = props.history.location.pathname,
    //   push = () => { if (pathname.includes('/cluster-info/') || pathname.includes('/workspace-info/') || pathname.includes('/namespace-info/')) props.history.push('/clusters') };
    if (clusters && clusters.length) {
      const data: string = sessionStorage.getItem("cluster") || "",
        selected = clusters.find((cluster: clusters_type_item) => cluster.metadata && cluster.metadata.name === data);
      if (selected) set_cluster_selected(selected.metadata);
      else {
        const { metadata }: clusters_type_item = clusters[0];
        set_cluster_selected(metadata);
        sessionStorage.setItem("cluster", metadata?.name);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clusters, set_cluster_selected]);

  useEffect((): void => {
    // const pathname = props.history.location.pathname,
    //   push = () => { if (pathname.includes('/workspace-info/') || pathname.includes('/namespace-info/')) props.history.push('/cluster-info/workspaces') };
    if (workspaces?.length) {
      const data: string | null = sessionStorage.getItem("workspace") || null,
        selected = workspaces?.find((workspace: workspaces_type_item) => workspace.metadata && workspace.metadata.name === data);
      if (selected) set_workspace_selected(selected.metadata);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaces, set_workspace_selected]);

  useEffect((): void => {
    // const pathname = props.history.location.pathname,
    //   push = () => { if (pathname.includes('/namespace-info/') || pathname.includes('/namespace-info/')) props.history.push('/cluster-info/namespaces') };
    if (namespaces?.length) {
      const data: string = sessionStorage.getItem("namespace") || "";
      const selected = namespaces?.find((namespace: namespaces_type_item) => namespace.metadata && namespace.metadata.name === data);
      if (selected) set_namespace_selected(selected.metadata);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [namespaces, set_namespace_selected]);

  return (
    <Row className="px-6" gutter={4}>
      <Col xs={24} sm={12} xl={8} xxl={8} style={{ lineHeight: 2 }}>
        <DropdownMenuSubscription />
      </Col>
      {display.cluster && (
        <Col xs={24} sm={12} xl={8} xxl={5} className="d-flex">
          {clusters && clusters[0] && clusters[0].metadata && (
            <Fragment>
              <div style={{ lineHeight: 2, minWidth: '121px' }} className="font-14 text-right">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <FormattedMessage id="cluster" />:
              </div>
              <Select
                className="w-70 pl-20 mb-5"
                showSearch
                optionFilterProp="children"
                value={(cluster_selected || {}).name || sessionStorage.getItem("cluster") || clusters[0].metadata.name}
                onChange={(event: string) => {
                  set_workspaces(undefined);
                  set_namespaces(undefined);
                  set_workspace_selected(undefined);
                  set_namespace_selected(undefined);
                  sessionStorage.removeItem("workspace");
                  sessionStorage.removeItem("namespace");
                  const cluster_selected_new: item | undefined = (clusters.find((cluster: clusters_type_item) => cluster.metadata.name === event) || {})
                    .metadata;
                  sessionStorage.setItem("cluster", (cluster_selected_new || {}).name || "");
                  set_cluster_selected(cluster_selected_new);
                }}
              >
                {Array.isArray(clusters) &&
                  clusters.map((cluster: clusters_type_item) => (
                    <Option key={cluster.metadata.name} value={cluster.metadata.name}>
                      {cluster.metadata.name}
                    </Option>
                  ))}
              </Select>
            </Fragment>
          )}
        </Col>
      )}
      {display.workspace && (
        <Col xs={24} sm={12} xl={8} xxl={5} className="d-flex">
          {workspaces && (
            <Fragment>
              <div style={{ lineHeight: 2, minWidth: '121px' }} className="font-14 text-right">
                <FormattedMessage id="workspace" />:
              </div>
              <Select
                className="w-70 pl-20 mb-5"
                showSearch
                optionFilterProp="children"
                disabled={!workspaces.length}
                value={workspace_selected?.labels ? workspace_selected.labels?.name : workspaces[0]?.metadata?.labels?.name}
                style={{ width: "100%", paddingLeft: 2 }}
                onChange={(event: string) => {
                  select(event, set_workspace_selected, true, workspaces);
                  set_namespaces(undefined);
                  set_namespace_selected(undefined);
                  sessionStorage.removeItem("namespace");
                }}
              >
                {workspaces.length ? (
                  workspaces.map((workspace: workspaces_type_item | undefined, index: number) => (
                    <Option key={workspace?.metadata?.uid ? workspace?.metadata?.uid : index} value={workspace?.metadata?.labels?.name || ""}>
                      {workspace?.metadata?.labels?.name}
                    </Option>
                  ))
                ) : (
                    <Option key="empty" value="Empty">
                      Empty
                    </Option>
                  )}
              </Select>
            </Fragment>
          )}
        </Col>
      )}
      {display.namespace && (
        <Col xs={24} sm={12} xl={8} xxl={5} className="d-flex">
          {namespaces && (
            <Fragment>
              <div style={{ lineHeight: 2, minWidth: '121px' }} className="font-14 text-right">
                <FormattedMessage id="namespace" />:
              </div>
              <Select
                className="w-70 pl-20 mb-5"
                showSearch
                optionFilterProp="children"
                disabled={!namespaces.length}
                value={
                  namespaces?.length ? (namespace_selected?.name ? namespace_selected?.name : (is_not_monitor || user_info.is_namespacedeveloper ? namespaces[0]?.metadata?.name : "")) : "Empty"
                }
                style={{ width: "100%", paddingLeft: 2 }}
                onChange={(event: string) => select(event, set_namespace_selected, false, namespaces)}
              >
                {namespaces.length ? (
                  (is_not_monitor || user_info.is_namespacedeveloper ? namespaces : [undefined, ...namespaces]).map((namespace: namespaces_type_item | undefined) => (
                    <Option key={namespace?.metadata?.uid || "all"} value={namespace?.metadata?.name || ""}>
                      {namespace?.metadata?.name || formatMessage({ id: "all" })}
                    </Option>
                  ))
                ) : (
                    <Option key="empty" value="Empty">
                      Empty
                    </Option>
                  )}
              </Select>
            </Fragment>
          )}
        </Col>
      )}
    </Row>
  );
};

export default injectIntl(withRouter(DropdownMenuTop) as any);
